import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'portafolio', loadChildren: () => import('./components/portfolio/portfolio.module').then(m => m.PortfolioModule) },
  { path: 'servicios', loadChildren: () => import('./components/services/services.module').then(m => m.ServicesModule) },
  { path: 'contacto', loadChildren: () => import('./components/contact/contact.module').then(m => m.ContactModule) },
  { path: 'sobre-mi', loadChildren: () => import('./components/about-me/about-me.module').then(m => m.AboutMeModule) },
  { path: 'proyectos', loadChildren: () => import('./components/project/project.module').then(m => m.ProjectModule) },
  { path: '**', pathMatch: 'full', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
